module.exports = __webpack_public_path__ + "img/dash-board-composition.835b3e1.svg";